<script>
import { extractFileData } from "../api";

export default {
  name: "EssaySummarizeForm",
  data() {
    return {
      essayContents: "",
      essayFile: null,
      loading: false,
      error: "",
      showFileUpload: true,
      showPlainText: false,
      fileVariant: "secondary",
      plainTextVariant: "outline-secondary",
    };
  },
  computed: {
    canSubmit() {
      return this.essayContents || this.essayFile;
    },
  },
  methods: {
    async onSubmit(e) {
      e.preventDefault();

      if (this.canSubmit) {
        if (this.essayFile) {
          try {
            this.loading = true;

            const formData = new FormData();

            formData.append("file", this.essayFile);

            const { data } = await extractFileData(formData);

            const payload = {
              content: data,
            };

            this.loading = false;
            this.error = "";

            this.$emit("essaySubmitted", payload);
          } catch (error) {
            this.loading = false;
            this.error = error.response?.data?.error;
          }
        } else {
          const payload = {
            content: this.essayContents,
          };

          this.$emit("essaySubmitted", payload);
        }
      } else {
        this.error = this.$t("essays.aiDetector.missingFormData");
      }
    },
    handleFileClick() {
      this.fileVariant = "secondary";
      this.plainTextVariant = "outline-secondary";
      this.showPlainText = false;
      this.showFileUpload = true;
    },
    handlePlainTextClick() {
      this.fileVariant = "outline-secondary";
      this.plainTextVariant = "secondary";
      this.showPlainText = true;
      this.showFileUpload = false;
    },
  },
};
</script>

<template>
  <div>
    <eg-b-alert v-if="error" variant="danger" show>{{ error }}</eg-b-alert>
    <eg-b-button-group>
      <eg-b-button :variant="fileVariant" @click="handleFileClick">{{
        $t("essays.aiDetector.file")
      }}</eg-b-button>
      <eg-b-button :variant="plainTextVariant" @click="handlePlainTextClick"
        >{{ $t("essays.plainText") }}
      </eg-b-button>
    </eg-b-button-group>
    <eg-b-form @submit="onSubmit">
      <eg-b-form-group
        v-if="showFileUpload"
        id="upload-group"
        class="mt-3"
        :description="$t('essays.aiDetector.supportedFileTypes')"
      >
        <eg-b-form-file
          id="upload"
          v-model="essayFile"
          accept=".pdf,.txt,.docx"
          :placeholder="$t('essays.aiDetector.chooseFile')"
          :drop-placeholder="$t('essays.aiDetector.dropFile')"
        ></eg-b-form-file>
      </eg-b-form-group>
      <eg-b-form-group v-if="showPlainText" id="textarea-group">
        <eg-b-form-textarea
          id="textarea"
          v-model="essayContents"
          :placeholder="$t('essays.aiDetector.pasteEssay')"
          rows="12"
          max-rows="24"
        ></eg-b-form-textarea>
      </eg-b-form-group>
      <div class="text-right">
        <eg-b-button
          type="submit"
          variant="info"
          :disabled="loading"
          class="summarize-btn"
          >{{ $t("essays.summarize") }}
        </eg-b-button>
      </div>

      <p v-if="loading">{{ $t("essays.parsingPdfText") }}</p>
    </eg-b-form>
  </div>
</template>
